import { HGAnyRecordSerialized } from "../../../common/types";

import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface RecordsState {
  recordsRefetchCounter: number;
  showedCollections: string[];
  db: HGAnyRecordSerialized[];
  dbLoaded: boolean;
  dbCounts: Record<string, number>;
  gmail: HGAnyRecordSerialized[];
  gmailLoaded: boolean;
  gmailCount: number | null;
  gmailExhausted: boolean;
}

const initialRecordsState: RecordsState = {
  recordsRefetchCounter: 0,
  showedCollections: [],
  db: [],
  dbLoaded: true,
  dbCounts: {},
  gmail: [],
  gmailLoaded: true,
  gmailCount: null,
  gmailExhausted: false,
};

export const recordsSlice = createSlice({
  name: "records",
  initialState: initialRecordsState,
  reducers: {
    incrementRecordsRefetchCounter(state) {
      state.recordsRefetchCounter += 1;
    },
    setShowedCollections(state, action: PayloadAction<string[]>) {
      state.showedCollections = action.payload;
    },
    setDBRecords: (state, action: PayloadAction<HGAnyRecordSerialized[]>) => {
      state.db = action.payload;
      return state;
    },
    setDBLoaded: (state, action: PayloadAction<boolean>) => {
      state.dbLoaded = action.payload;
    },
    setGmailRecords: (
      state,
      action: PayloadAction<HGAnyRecordSerialized[]>,
    ) => {
      state.gmail = action.payload;
    },
    setGmailLoaded: (state, action: PayloadAction<boolean>) => {
      state.gmailLoaded = action.payload;
    },
    setGmailCount: (state, action: PayloadAction<number | null>) => {
      state.gmailCount = action.payload;
    },
    setGmailExhausted: (state, action: PayloadAction<boolean>) => {
      state.gmailExhausted = action.payload;
    },
  },
});

export const {
  incrementRecordsRefetchCounter,
  setShowedCollections,
  setDBRecords,
  setDBLoaded,
  setGmailRecords,
  setGmailLoaded,
  setGmailCount,
  setGmailExhausted,
} = recordsSlice.actions;

export const selectRecordsRefetchCounter = (state: RootState) =>
  state.records.recordsRefetchCounter;

export const selectShowedCollections = (state: RootState) =>
  state.records.showedCollections;

export const selectDBRecords = (state: RootState) => state.records.db;
export const selectGmailRecords = (state: RootState) => state.records.gmail;

export const selectDBLoaded = (state: RootState) => state.records.dbLoaded;
export const selectGmailLoaded = (state: RootState) =>
  state.records.gmailLoaded;

export const selectGmailCount = (state: RootState) => state.records.gmailCount;

export const selectGmailExhausted = (state: RootState) =>
  state.records.gmailExhausted;

export const selectRecordsAreLoaded = createSelector(
  [selectDBLoaded, selectGmailLoaded],
  (dbLoaded, gmailLoaded) => dbLoaded && gmailLoaded,
);

export default recordsSlice.reducer;
